export { default as NotFoundPage } from './not-found.page';
